/**
 * Normalizes the server's JSON response into the shape the UI renders.
 *
 * Server contract (see api/drishti/chat.js):
 *   { tag, text, evidence: { kind, table, rows, insight_title, insight_rule } }
 *
 * UI shape adds a couple of convenience fields and defends against partial
 * responses on timeout / error paths.
 */

export const VALID_TAGS = ['from_audit_data', 'from_analysis', 'no_answer'];

export const TAG_LABELS = {
  from_audit_data: 'From audit data',
  from_analysis: 'From analysis',
  no_answer: 'No answer',
};

export function parseDrishtiResponse(raw) {
  if (!raw || typeof raw !== 'object') {
    return safeRefusal('empty response');
  }

  const tag = VALID_TAGS.includes(raw.tag) ? raw.tag : 'no_answer';
  const text =
    typeof raw.text === 'string' && raw.text.trim().length > 0
      ? raw.text.trim()
      : "Sorry, I don't have current analysis on that.";

  const evidence = normalizeEvidence(raw.evidence);

  return { tag, text, evidence };
}

function normalizeEvidence(e) {
  if (!e || typeof e !== 'object') return null;

  if (e.kind === 'table' && typeof e.table === 'string') {
    return {
      kind: 'table',
      table: e.table,
      rows: Array.isArray(e.rows) ? e.rows : [],
    };
  }

  if (e.kind === 'insight' && typeof e.insight_title === 'string') {
    return {
      kind: 'insight',
      title: e.insight_title,
      rule: typeof e.insight_rule === 'string' ? e.insight_rule : '',
    };
  }

  return null;
}

function safeRefusal(reason) {
  return {
    tag: 'no_answer',
    text: "Sorry, I don't have current analysis on that.",
    evidence: null,
    _reason: reason,
  };
}
